<div class = "confirmationPopup">   
    <div mat-dialog-content>
        <div class="mat-card-header-text confirmHeader" i18n>Delete User</div>
        <p class="confirmQuestion" i18n>Are you sure you want to delete the selected user?</p>
        <div mat-dialog-actions>
            <div class="confirmButton">      
                <button mat-raised-button type="button" tabindex="-1" class="mat-focus-indicator mat-raised-button mat-button-base mat-primary" color="primary" (click)="ConfirmDelete()" i18n>CONFIRM</button>               
            </div> 
        </div>
    </div>   
</div>